module.exports = __webpack_public_path__ + "static/media/web-development.3fa2fbe7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/web-development.svg
// module id = 327
// module chunks = 0